<template>
<div>
    <!-- modal -->
    <b-modal id="lawMatterEvidenceDetectionCounterPartyFormModal" ref="lawMatterEvidenceDetectionCounterPartyFormModal"
     centered size="customize" no-close-on-backdrop :title=" $t('lawMatterEvidenceDetectionCounterParty.info')" 
     :cancel-title=" $t('others.cancel_title')" :ok-title=" $t('others.ok_title')" cancel-variant="outline-secondary" @ok.prevent="addOrUpdate">
        <b-row>
             <b-col class="col-lg-6">
                    <b-form>
                        <label>{{ $t('lawMatterEvidenceDetectionCounterParty.counter_party') }}</label>
                        <b-form-group>
                            <b-form-select size="sm" v-model="counterPartySelect" value-field="id" text-field="name" :options="counterPartyOptions"/>
                        </b-form-group>
                    </b-form>
              </b-col>
              <b-col class="col-lg-6">
                    <b-form>
                        <label>{{ $t('lawMatterEvidenceDetectionCounterParty.counter_party_attorney') }}</label>
                        <b-form-group>
                            <b-form-select size="sm" v-model="counterPartyAttorneySelect" value-field="id" text-field="name" :options="counterPartyAttorneyOptions"/>
                        </b-form-group>
                    </b-form>
              </b-col>
           
        </b-row>
    </b-modal>
</div>
</template>

  
<script>
export default {
    props: {
        getLawMatterEvidenceDetectionCounterPartyList: {
            type: Function
        },
        lawMatterEvidenceDetectionId: {
            type: Number
        }

    },
    data() {
        return {
           id: 0,
           counterPartyOptions:[],
           counterPartySelect: 0,
           counterPartyAttorneyOptions:[],
           counterPartyAttorneySelect: 0,
        }
    },
    methods: {
        showInfo(id) {
            this.$refs['lawMatterEvidenceDetectionCounterPartyFormModal'].show()
            this.id = id
            const data = {
                id: this.id
            }
            const controller = {
                name: 'LawMatterEvidenceDetectionCounterParty'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$store.dispatch('moduleAuth/getInfo', payload).then((response) => {
                if (response.data.resultStatus == true) {

                       this.counterPartyOptions = response.data.lawCounterPartyList
                       this.counterPartyOptions.splice(0, 0, this.$nullSelected())
                       this.counterPartySelect = response.data.lawMatterEvidenceDetectionCounterParty.lawCounterPartyId

                       this.counterPartyAttorneyOptions = response.data.lawCounterPartyAttorneyList
                       this.counterPartyAttorneyOptions.splice(0, 0, this.$nullSelected())
                       this.counterPartyAttorneySelect = response.data.lawMatterEvidenceDetectionCounterParty.lawCounterPartyAttorneyId

                       
                } else {
                    this.$bvModal.hide('lawMatterEvidenceDetectionCounterPartyFormModal')
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
        },
        addOrUpdate() {
            const data = {
                id: this.id,
                lawCounterPartyId: this.counterPartySelect,
                lawCounterPartyAttorneyId :this.counterPartyAttorneySelect,
                lawMatterEvidenceDetectionId: this.lawMatterEvidenceDetectionId
            }
            const controller = {
                name: 'LawMatterEvidenceDetectionCounterParty'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$store.dispatch('moduleAuth/save', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.$bvModal.hide('lawMatterEvidenceDetectionCounterPartyFormModal')
                    this.getLawMatterEvidenceDetectionCounterPartyList()
                    this.$SaveAlert()
                } else {
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
        },
    }
}
</script>
  
<style lang="scss">
[dir=ltr] .modal-header .close {
    margin: -0.4rem -0.4rem -0.8rem auto;
}

[dir] label {
    margin-bottom: 0.2857rem;
    font-weight: bold;
}

.modal .modal-content {
    overflow: visible;
    margin-bottom: auto;
}

[dir] .invalid-tooltip {
    padding: 0.4rem 0.775rem !important;
    margin-top: -1.5rem !important;
    background-color: #ea5455 !important;
    border-radius: 0.358rem !important;
    left: 20px !important
}

</style>
